export const holidaysModel: Array<string> = [
    'Mon Feb 12 2024', //Carnaval
    'Tue Feb 13 2024', //Carnaval
    'Fri Mar 29 2024', //Viernes Santo
    'Mon Apr 01 2024', //Fines turisticos
    'Tue Apr 02 2024', //Veteranos de Malvinas
    'Wed May 01 2024', //Dia del Trabajador
    'Mon Jun 17 2024', //Inmortalidad Guemes
    'Thu Jun 20 2024', //Inmortalidad Belgrano
    'Fri Jun 21 2024', //Fines turisticos
    'Tue Jul 09 2024', //Dia de la independencia
    'Fri Oct 11 2024', //Fines turisticos
    'Mon Nov 18 2024', //Soberania Nacional
    'Wed Dec 25 2024' //Navidad
];
